export default __webpack_public_path__ + "static/media/money_bag.37587a48.svg";